export default __webpack_public_path__ + "static/media/2.e0fdefa5.png";